export default {
  data() {
    return {
      inputType: 'select',
      inputTypeDef: {}
    }
  }
}
